import WatchTransformBelong from './WatchTransformBelong'

export default WatchTransformBelong
// eslint-disable-next-line import/export
export * from './WatchTransformBelong'
